/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_TenantInputs */

const cs_enum_tenant = /** @type {(inputs: Enum_TenantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nájemník`)
};

const en_enum_tenant = /** @type {(inputs: Enum_TenantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tenant`)
};

/**
* | output |
* | --- |
* | "Tenant" |
*
* @param {Enum_TenantInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_tenant = /** @type {((inputs?: Enum_TenantInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_TenantInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_tenant(inputs)
	return cs_enum_tenant(inputs)
});